import { render, staticRenderFns } from "./dashboard.view.vue?vue&type=template&id=37387fb4&scoped=true"
import script from "./dashboard.view.vue?vue&type=script&lang=js"
export * from "./dashboard.view.vue?vue&type=script&lang=js"
import style0 from "./dashboard.view.vue?vue&type=style&index=0&id=37387fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37387fb4",
  null
  
)

export default component.exports